import {
  ecpStoresCached,
  filterParams,
  sortingType,
  setStoreDetail,
  setUserLocation,
  setStoreCode,
  setAutocompletedSearch,
} from './ecp-locator.cache';

export const ecpLocator = {
  read() {
    return {
      ecpStoresCached: ecpStoresCached(),
      userLocation: setUserLocation(),
      storeDetail: setStoreDetail(),
      filterParams: filterParams(),
      sortingType: sortingType(),
      storeCode: setStoreCode(),
      isAutocompletedSearch: setAutocompletedSearch(),
    };
  },
};
